// Dictionary file for global constants
export const CONSTANTS = {
  EMPTY_STRING: '',
  DATE_FORMAT: 'YYYY-MM-DD',
  DEFAULT_DATETIME_FORMAT: 'MMM D, YYYY hh:mm:ss A',
  NOT_APPLICABLE: 'n/a',
  NO_DATA: 'no_data_label',
  API_METHOD: {
    POST: 'POST',
    GET: 'GET',
    PUT: 'PUT',
  },
  DASHBOARD_TYPES: {
    DEVICE: 'device',
    SMARTBATTERY: 'smartbattery',
    WATCHLIST: 'watchlist',
    UTILIZATION: 'util'
  },
  NO_DASHBOARD_PAGE_ID: 'nodashboardpage',
  NO_DASHBOARD_URL: '/applications/dashboardnotfound',
  APPLICATION_TYPE: {
    ICU: 'icu',
    DATA_USAGE: 'datausage',
    APP_USAGE: 'appusage',
    BATTERY: 'battery',
    GENERAL: 'general',
  },
  NOTICE: {
    MobiControlApi: {
      text: `In order to collect the information required for the MobiControl API you will need to switch on data
    collection and frequency in MobiControl for the insights ICU to perform as you require. We suggest switching on
    collection of all items you wished to monitor and setting the frequency from your MobiControl devices to hourly or
    less.`,
    },
    InsightAndroidAgent: {
      text: `Please Note: By setting up ICU, you may have selected attributes that one or more of your data sources
      is not currently provisioned to collect. If this is the case, Insight will automatically begin collecting
      this attribute for the selected data sources at the default collection frequency of hourly.`,
    },
  },
};
